function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { storageCateApi, storageDeleteApi, storageListApi, storageListCateApi } from '@/api/administration';
export default {
  name: 'Consume',
  components: {
    tree: function tree() {
      return import('./tree');
    },
    addMaterial: function addMaterial() {
      return import('./addMaterial');
    },
    receive: function receive() {
      return import('./receive');
    },
    record: function record() {
      return import('./record');
    },
    returnMaterial: function returnMaterial() {
      return import('./return');
    },
    materialDialog: function materialDialog() {
      return import('./materialDialog');
    },
    exportExcel: function exportExcel() {
      return import('@/components/common/exportExcel');
    },
    oaFromBox: function oaFromBox() {
      return import('@/components/common/oaFromBox');
    },
    oaDialog: function oaDialog() {
      return import('@/components/form-common/dialog-form');
    }
  },
  data: function data() {
    return {
      pickerOptions: this.$pickerOptionsTimeEle,
      alertText: '固定物资经过领取之后，领取人只为借用，最终需要归还给公司，例如：电脑、显示器等。',
      gridl: {
        xl: 3,
        lg: 4,
        md: 5,
        sm: 6,
        xs: 24
      },
      gridr: {
        xl: 21,
        lg: 20,
        md: 19,
        sm: 18,
        xs: 24
      },
      fromData1: {
        width: '500px',
        title: '批量移动物资分类',
        btnText: '确定',
        labelWidth: '80px',
        type: ''
      },
      formDataInit: {
        cate_id: '',
        ids: []
      },
      formRules: {
        cate_id: [{
          required: true,
          message: '请选择物资类别',
          trigger: 'change'
        }]
      },
      treeData: [],
      formConfig: [],
      frame_id: 0,
      where: {
        page: 1,
        limit: 15,
        types: 1,
        cid: ''
      },
      search: [{
        field_name: '物资名称/物资编号',
        field_name_en: 'name',
        form_value: 'input'
      }, {
        field_name: '物资状态',
        field_name_en: 'status',
        form_value: 'select',
        data_dict: [{
          value: '',
          name: '全部'
        }, {
          value: '0',
          name: '未使用'
        }, {
          value: 1,
          name: '已领用'
        }, {
          value: 3,
          name: '维修中'
        }, {
          value: 4,
          name: '已报废'
        }]
      }, {
        field_name: '入库时间',
        field_name_en: 'time',
        form_value: 'date_picker'
      }],
      dropdownList: [{
        label: '批量移动',
        value: '4'
      }, {
        label: '导出',
        value: '1'
      }, {
        label: '领用',
        value: '2'
      }, {
        label: '归还',
        value: '3'
      }],
      total: 0,
      tableData: [],
      fromData: {},
      receiveData: {},
      recordData: {},
      returnData: {},
      materialData: {},
      options: [],
      selectData: [],
      multipleSelection: [],
      types: 1,
      saveName: '',
      exportData: {
        data: [],
        cols: [{
          wpx: 120
        }, {
          wpx: 120
        }, {
          wpx: 120
        }, {
          wpx: 80
        }, {
          wpx: 80
        }, {
          wpx: 80
        }, {
          wpx: 80
        }, {
          wpx: 180
        }, {
          wpx: 180
        }]
      }
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    confirmData: function confirmData(data) {
      if (data == 'reset') {
        this.where = {
          page: 1,
          limit: 15,
          types: 1,
          cid: ''
        };
      } else {
        this.where = _objectSpread(_objectSpread({}, this.where), data);
        this.where.page = 1;
      }
      this.getTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var _this = this;
      this.multipleSelection = [];
      val.map(function (item) {
        _this.multipleSelection.push(item.id);
      });
    },
    // 获取权限列表
    getList: function getList() {
      var _this2 = this;
      storageCateApi({
        type: this.types
      }).then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _this2.treeData = res.data;
                _this2.formConfig = [{
                  type: 'cascaderNew',
                  label: '物资类别:',
                  placeholder: '请搜索选择物资类别',
                  key: 'cate_id',
                  options: _this2.treeData
                }];
                _this2.getTableData();
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (error) {});
    },
    handleSizeChange: function handleSizeChange(val) {
      this.where.limit = val;
      this.getTableData();
    },
    pageChange: function pageChange(page) {
      this.where.page = page;
      this.getTableData();
    },
    dropdownFn: function dropdownFn(item) {
      if (item.value == 1) {
        this.handleExport();
      } else if (item.value == 2) {
        this.handleReceive();
      } else if (item.value == 3) {
        this.handleReturn();
      } else if (item.value == 4) {
        if (this.multipleSelection.length == 0) return this.$message.error('请选择要操作的物资');
        this.$refs.oaDialog.openBox();
      }
    },
    submit: function submit(data) {
      var _this3 = this;
      data.ids = this.multipleSelection;
      data.cate_id = data.cate_id[data.cate_id.length - 1];
      storageListCateApi(data).then(function (res) {
        if (res.status == 200) {
          _this3.$refs.oaDialog.handleClose();
          _this3.getTableData();
        }
      });
    },
    handleExport: function handleExport() {
      var _this4 = this;
      // 先将对象变为字符串，然后再变为json对象，防止对象的指针指向问题，为深拷贝
      var where = JSON.parse(JSON.stringify(this.where));
      where.limit = 0;
      this.saveName = '导出固定物资_' + this.$moment(new Date()).format('MM_DD_HH_mm_ss') + '.xlsx';
      storageListApi(where).then(function (res) {
        var data = res.data.list;
        if (data.length <= 0) {
          _this4.$message.error(_this4.$t('access.placeholder24'));
        } else {
          var aoaData = [['物资编号', '物资名称', '规格型号', '物资分类', '物资单价', '计量单位', '物资状态', '重要信息', '创建时间']];
          data.forEach(function (value) {
            aoaData.push([value.number, value.name, value.units, value.cate ? value.cate.cate_name : '', value.record[0].price, value.specs, _this4.getMaterialStatus(value.status), value.remark, value.created_at]);
          });
          _this4.exportData.data = aoaData;
          _this4.$refs.exportExcel.exportExcel();
        }
      }).catch(function (error) {});
    },
    // 获取表格数据
    getTableData: function getTableData() {
      var _this5 = this;
      storageListApi(this.where).then(function (res) {
        _this5.tableData = res.data.list || [];
        _this5.total = res.data.count;
      }).catch(function (error) {});
    },
    getSelectTableData: function getSelectTableData(status) {
      var _this6 = this;
      var distinct = status === '' ? 'name' : '';
      storageListApi({
        types: this.types,
        page: 0,
        distinct: distinct,
        limit: 0,
        status: status
      }).then(function (res) {
        _this6.selectData = res.data.list || [];
        if (status === 0) {
          // 领用物资列表
          _this6.receiveData.selectData = _this6.selectData;
        } else if (status === '') {
          // 领用新增物资列表
          _this6.fromData.selectData = _this6.selectData;
        }
      });
    },
    handleSearch: function handleSearch() {
      this.where.page = 1;
      this.getTableData();
    },
    handleMaterial: function handleMaterial() {},
    onchangeTime: function onchangeTime(e) {
      if (e == null) {
        this.timeVal = '';
        this.where.time = '';
      } else {
        this.where.time = this.timeVal[0] + '-' + this.timeVal[1];
      }
      this.handleSearch();
    },
    getFrameId: function getFrameId(data) {
      this.where.cid = data ? data : '';
      this.where.page = 1;
      this.getTableData();
    },
    handleManage: function handleManage() {
      this.getSelectTableData('');
      this.fromData = {
        title: '新增入库(固定物资)',
        width: 720,
        treeData: this.treeData,
        selectData: this.selectData,
        edit: false,
        type: this.types
      };
      this.$refs.addMaterial.openBox();
    },
    handleReceive: function handleReceive() {
      this.getSelectTableData(0);
      this.receiveData = {
        title: '领用(固定物资)',
        width: 820,
        selectData: this.selectData,
        type: this.types
      };
      this.$refs.receive.openBox();
    },
    handleReturn: function handleReturn() {
      this.returnData = {
        title: '归还(固定物资)',
        width: 820,
        type: this.types
      };
      this.$refs.returnMaterial.openBox();
    },
    handleRecord: function handleRecord(row) {
      this.recordData = {
        title: '记录详情(固定物资)',
        width: 820,
        data: row,
        type: this.types
      };
      this.$refs.record.where.storage_id = row.id;
      this.$refs.record.usersWhere.storage_id = row.id;
      this.$refs.record.openBox();
    },
    getMaterialStatus: function getMaterialStatus(value) {
      var str = '';
      if (value === 0) {
        str = '未使用';
      } else if (value === 1) {
        str = '已领用';
      } else if (value === 2) {
        str = '已归还';
      } else if (value === 3) {
        str = '维修中';
      } else if (value === 4) {
        str = '已报废';
      }
      return str;
    },
    handleEdit: function handleEdit(row) {
      if (row.cate.path.length <= 0) {
        row.cate.path.unshift(0); // 添加总分类
      }
      if (!row.cate.path.includes(row.cid)) {
        row.cate.path.push(row.cid); // 添加当前分类
      }
      this.fromData = {
        title: '编辑入库(固定物资)',
        width: 720,
        treeData: this.treeData,
        edit: true,
        data: row,
        type: this.types
      };
      this.$refs.addMaterial.openBox();
    },
    handleDelete: function handleDelete(id) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var totalPage, currentPage;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this7.$modalSure('你确定要删除这条内容吗');
            case 2:
              _context2.next = 4;
              return storageDeleteApi(id);
            case 4:
              totalPage = Math.ceil((_this7.total - 1) / _this7.where.limit);
              currentPage = _this7.where.page > totalPage ? totalPage : _this7.where.page;
              _this7.where.page = currentPage < 1 ? 1 : currentPage;
              _context2.next = 9;
              return _this7.getTableData();
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    handleMaterialData: function handleMaterialData(type, row) {
      var title = '';
      var label = '';
      var placeholder = '';
      if (type === 1) {
        title = '报废';
        label = '报废原因';
        placeholder = '请输入报废原因';
      } else if (type === 2) {
        title = '维修';
        label = '维修原因';
        placeholder = '请输入维修原因';
      } else if (type === 3) {
        title = '维修处理';
        label = '备 注';
        placeholder = '请输入备注';
      }
      this.materialData = {
        title: title,
        width: '520px',
        label: label,
        placeholder: placeholder,
        data: row,
        type: type
      };
      this.$refs.materialDialog.handleOpen();
    }
  }
};